/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectChangeOrderByIdQuery } from '../../models/get-project-change-order-by-id-query';
import { GetProjectChangeOrderByIdQueryResult } from '../../models/get-project-change-order-by-id-query-result';

export interface ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Params {
      body?: GetProjectChangeOrderByIdQuery
}

export function apiProjectChangeOrderGetProjectChangeOrderByIdPost(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrderByIdQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderGetProjectChangeOrderByIdPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectChangeOrderByIdQueryResult>;
    })
  );
}

apiProjectChangeOrderGetProjectChangeOrderByIdPost.PATH = '/api/ProjectChangeOrder/GetProjectChangeOrderById';
